import Updater from '../helpers/Updater';

;$(function() {

    $(document).on('click', '#new-lots-counter', function() {
        window.location.href = '/';
    });

});